import { Form, Formik } from 'formik'
import { MdEmail } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { useActionData, useLocation, useSubmit } from 'react-router-dom'
import * as Yup from 'yup'
import Headline from '../Components/Elements/Headline'
import Text from '../Components/Elements/Text'
import Button from '../Components/Formik/Button'
import Input from '../Components/Formik/Input'
import * as UserAPI from '../lib/API/UserAPI'

export const login = async ({ params, request }) => {
  const formData = await request.formData()

  UserAPI.sendMagicLink(formData.get('email'))

  return true
}

export default function LoginPage() {
  const { t } = useTranslation(['login', 'common'])
  const isMagicLinkSent = useActionData()
  const { state } = useLocation()
  const submit = useSubmit()

  if (isMagicLinkSent) {
    return (
      <>
        <Headline>{t('login:magicLinkSent.heading')}</Headline>
        <Text className='mt-4'>{t('login:magicLinkSent.body')}</Text>
      </>
    )
  }

  return (
    <>
      <Headline>{state?.message || t('login:title')}</Headline>
      <Text>{t('login:intro')}</Text>
      <div className='mt-8'>
        <Formik
          initialValues={{
            email: '',
          }}
          validationSchema={Yup.object({
            email: Yup.string()
              .matches(
                /^[A-ZÆØÅ0-9._%+-]+@[A-ZÆØÅ0-9.-]+.[A-ZÆØÅ]{2,}$/i,
                t('login:invalidEmail'),
              )
              .required(t('common:validation.required')),
          })}
          onSubmit={(values) => {
            submit(values, { method: 'post' })
          }}
        >
          <Form>
            <div className='flex flex-col mb-6'>
              <Input
                name='email'
                placeholder={t('login:emailPlaceholder')}
                icon={<MdEmail />}
              />
            </div>
            <div className='flex w-full'>
              <Button type='submit'>{t('login:submit')}</Button>
            </div>
          </Form>
        </Formik>
      </div>
    </>
  )
}
